import React from "react";
import { Controller, useForm } from "react-hook-form";
import InputAdornment from "@material-ui/core/InputAdornment";
import Box from "@material-ui/core/Box";
import TextField from "lib/components/TextField";
import IconSearch from "lib/assets/search.svg";
import { useRouter } from "next/router";

interface SearchFormProps {
  defaultValue?: string;
}

const SearchForm: React.FC<SearchFormProps> = ({ defaultValue }) => {
  const { push } = useRouter();
  const {
    control,
    formState: { isSubmitting },
    handleSubmit,
  } = useForm({
    defaultValues: { keyword: defaultValue || "" },
  });

  const handleOnSubmit = handleSubmit(async ({ keyword }) => {
    const trimmed = keyword.trim();
    if (trimmed) {
      await push(`/resources/search/${trimmed}`);
    }
  });

  return (
    <Box maxWidth="680px" width="100%">
      <form onSubmit={handleOnSubmit}>
        <Controller
          control={control}
          name="keyword"
          fullWidth
          rules={{ required: true }}
          render={(props) => (
            <TextField
              {...props}
              css={`
                &&&& input {
                  padding: 17px 16px;
                }
              `}
              fullWidth
              autoComplete="off"
              disabled={isSubmitting}
              placeholder="Enter an immigration related keyword"
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    css={`
                      margin-left: 6px;
                    `}
                    position="start"
                  >
                    <IconSearch
                      width={24}
                      height={24}
                      viewBox="0 0 20 20"
                      fill="black"
                    />
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </form>
    </Box>
  );
};

export default SearchForm;
